export default {
  pleaseEnterKeyWords: '请输入关键词',
  pleaseSelectAstandard: '请选择标准',
  parentClass: '上级类别',
  classAttribute: '类别属性',
  loading: '加载中',
  noMore: '没有更多了',
  noData: '暂无数据：请更换标准或类型',
  classSearch: '实体检索',
}
